import { Box, Grid, makeStyles, Theme } from '@freighthub/silhouette-core'
import classnames from 'classnames'
import { FC, ReactElement } from 'react'
import { useI18n } from 'utils/localisation'

import { IPdadItem } from '../domain/PdadTypes'
import { IShipTpEvent } from '../domain/TransportPlanEvent'
import { TPdadRecord } from '../service/PDAD'
import { tpPointToStr } from '../service/TransportPlan2'
import { PdadStepIcon } from './PdadIcon'
import { ProgressTrackableObject } from './ProgressTrackableObject'
import { TpEventTimestampRangeWithProvider } from './TpRange'
import { getContainersGroupTitle, PdadWrapper, TpTrackStepConnector } from './TpTrackStepConnector'

export const tpTrackStepTestId = 'tp-track-step'

const useStyles = makeStyles<Theme>((theme) => ({
  stepCircle: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
    padding: theme.spacing(1),
    borderRadius: '50%',
    backgroundColor: theme.palette.background.default,
    lineHeight: theme.spacing(6),
    width: 48,
    height: 48,
    zIndex: 100,
    color: theme.palette.grey[600],
  },
  stepCircleCompleted: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))

export interface TPStepProps {
  pdadWrappers: PdadWrapper[]
  pdadItem: IPdadItem
  prev: IPdadItem
  events: IShipTpEvent[]
  pdadStructure: TPdadRecord
  showTrackableTitle: boolean
  widthPercentage: number
}

export const TpTrackStep: FC<TPStepProps> = ({
  pdadWrappers,
  events,
  pdadItem,
  prev,
  pdadStructure,
  widthPercentage,
  showTrackableTitle,
}) => {
  const classes = useStyles()
  const { translate } = useI18n()

  const { passedActual, event, durationDays, pdadType } = pdadItem

  const structure = pdadStructure[pdadType]
  // @ts-expect-error TS(2339) FIXME: Property 'point' does not exist on type 'Pdad2 | u... Remove this comment to see the full error message
  const { point, stepUI, transportMode } = structure

  const width = `${widthPercentage}%`

  let eventTerm: string | ReactElement
  if (event?.aggregatedTimestamp?.confirmed && stepUI.confirmedLabelTerm) {
    eventTerm = stepUI.confirmedLabelTerm
  } else {
    eventTerm = passedActual || !event.aggregatedTimestamp ? stepUI.titleTerm : stepUI.estimatedLabelTerm
  }

  return (
    <Box flex={`1 0 ${width}`} position="relative" width={width} data-testid={tpTrackStepTestId}>
      <Grid container direction="column" alignItems="center">
        {prev && prev.event && (
          <TpTrackStepConnector
            pdadWrappers={pdadWrappers}
            durationDays={durationDays}
            transportMode={transportMode}
            showTrackableTitle={showTrackableTitle}
          />
        )}
        {showTrackableTitle &&
          pdadWrappers.map((pdadWrapper) => {
            if (!pdadWrapper.pdad.allowShowOnStep || pdadWrapper.isNextProgress) {
              return null
            }
            return (
              <ProgressTrackableObject
                key={pdadWrapper.trackableVisualInfo.containerIndex}
                inCircle
                // @ts-expect-error TS(2345) FIXME: Argument of type 'number[] | undefined' is not ass... Remove this comment to see the full error message
                title={getContainersGroupTitle(pdadWrapper.trackableVisualInfo.groupNumbers)}
              />
            )
          })}

        <div className={classnames(classes.stepCircle, { [classes.stepCircleCompleted]: passedActual })}>
          <PdadStepIcon iconType={stepUI.icon} />
        </div>
        {/* @ts-expect-error TS(2345) FIXME: Argument of type 'string | ReactElement<any, strin... Remove this comment to see the full error message */}
        <Box textAlign="center">{translate(eventTerm)}</Box>
        <Box textAlign="center" whiteSpace="nowrap">
          {event.aggregatedTimestamp && <TpEventTimestampRangeWithProvider events={events} />}
        </Box>
        <Box textAlign="center" whiteSpace="normal">
          {point ? tpPointToStr(point) : translate(stepUI.locationFallbackTerm)}
        </Box>
      </Grid>
    </Box>
  )
}
